import React, { useState, useRef, useCallback } from 'react';
import './Supplimentary.scss';
import { Form, LoadIndicator } from 'devextreme-react';
import { ButtonItem, ButtonOptions, CustomRule, GroupItem, Item, Label, RequiredRule } from 'devextreme-react/cjs/form';
import GlobalParams from '../../helpers/GlobalParams';
import axios from 'axios';
import notify from 'devextreme/ui/notify';

const isDateInRange = (date_from, date_to, check_date) => {
  return check_date >= date_from && check_date <= date_to;
}

function Supplimentary({ onClosePopup, schemeStore }) {

  var filesData = [];
  const [schemeCategoriesStore, setSchemeCategoriesStore] = useState([]);
  const [with_categories, set_with_categories] = useState(false);
  const [MemberAge, setMemberAge] = useState(0);
  const [MemberSalary, setMemberSalary] = useState(0);
  const [loading, setLoading] = useState(false);
  const formData = useRef({
    scheme_id: null,
    endorsement_type: 2,
    effective_date: new Date(),
    portal_user_id: GlobalParams.ContactPersonId,
    requested_change: '',
    MemberName: '',
    DateOfBirth: null,
    MemberNo: '',
    LoanAmount: 0,
    date_of_loan: null,
    duration: 0,
    //interest_rate: 0,
    loan_number: '',
    id_number: '',

    is_joint_life: 0,
    retrenchment_applicable: '',

    MemberEmail: '',
    premium_rate: 0,
    category_code: null,

    MemberAge: ''
  });

  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const calculateAge = (birthDate) => {
    const currentDate = new Date();
    const birthDateObj = new Date(birthDate);

    let age = currentDate.getFullYear() - birthDateObj.getFullYear();

    // Check if the birthday has occurred for this year
    if (currentDate.getMonth() < birthDateObj.getMonth() ||
      (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
      age--;
    }

    return age;
  };

  const postSchemeBalance = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "recalculate-scheme-balance",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } catch (error) {
      
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postDebits = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "post-debits-to-gl",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postSchemeBalance(scheme_id);
    } catch (error) {
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postAutomate = async (request_id, scheme_id) => {
    try {

      let post_data = {
        'request_id': request_id
      };
      console.log(post_data);
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "get-endorsements-processing-results",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postDebits(scheme_id);
      //console.log(result.data.request_id);
      console.log("Automation Request finished");
    } catch (error) {
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postData = async () => {
    try {
      let post_data = formData.current;
      console.log(post_data);
      //var post_data = postData;
      post_data.effective_date = new Date();
      //post_data.portal_user_id = GlobalParams.ContactPersonId;
      //LoanAmount, duration, interest_rate

      // post_data.LoanAmount = post_data.LoanAmount.replace(/[,!]/g, '');
      // post_data.duration = post_data.duration.replace(/[,!]/g, '');
      // post_data.interest_rate = post_data.interest_rate.replace(/[,!]/g, '');

      console.log(post_data);

      /*let tmp_filesData = filesData || [];

      if (post_data.HasDependants === true) {
        post_data.HasDependants = 1;
      } else {
        post_data.HasDependants = 0;
      }
      let tmp_dependantsData = dependantsData || [];


      //concertinate...
      let combinedHashmap = tmp_dependantsData.length > 0 ? tmp_dependantsData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          acc[`dependants[${index}][${key}]`] = obj[key];
        });
        return acc;
      }, { ...post_data }) : post_data;

      combinedHashmap = tmp_filesData.length > 0 ? tmp_filesData.reduce((acc, obj, index) => {
        // Assuming the formdata is the key 'key' in each object
        Object.keys(obj).forEach(key => {
          acc[`files[${key}]`] = obj[key];
        });
        return acc;
      }, { ...post_data }) : post_data;*/

      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "credit-life-endorsement-request",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      //console.log(result.status);
      setLoading(false);
      //clear_form();
      notify("New Loan successfully Added", 'success', 5000);
      //console.log("request id: " + result.data.data.request_id);
      postAutomate(result.data.data.request_id, post_data.scheme_id);
      onClosePopup();
    } catch (error) {
      // Handle error, e.g., show an error message
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const fetchCategories = async (schemeId) => {
    try {
      let url = GlobalParams.ApiUrlPrefix + 'scheme-categories?scheme_id=' + schemeId
      const result = await axios.get(
        url,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken
          }
        }
      );

      setSchemeCategoriesStore(result.data.data);
      //console.log(result.status);
      console.log(result.data.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      setLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const doSave = useCallback(async (e) => {
    e.preventDefault();
    //const { MemberName, MemberNo } = formData.current;
    setLoading(true);

    //post data
    postData();

  }, []);

  return (
    <div>
      {/* Design the supplimentary Form */}
      <form onSubmit={doSave}>
        <Form
          formData={formData.current}
          disabled={loading}
          colCount={1}
        >
          <GroupItem colCount={3} caption="">
            <Item
              colSpan={3}
              dataField="scheme_id"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: schemeStore,
                  displayExpr: "PolicyCompany",
                  valueExpr: "schemeID",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    //fetch the categories at these point
                    if (e.value !== undefined && e.value !== null && e.value !== '') {

                      var index = schemeStore.findIndex(function (item) {
                        return item.schemeID === e.value;
                      });
                      //setUseMemberRate(false);
                      set_with_categories(false);

                      // if(schemeStore[index]['UseMemberRate'] === "1"){
                      //   setUseMemberRate(true);
                      // }
                      if (index > -1) {
                        console.log(schemeStore[index]['with_categories']);
                        if (schemeStore[index]['with_categories'] === "1") {
                          set_with_categories(true);
                        }
                      }


                      fetchCategories(e.value);
                    }
                  }
                }
              }
            >
              <RequiredRule message="Policy No / Scheme is required" />
              <Label text='Policy No / Scheme' />
            </Item>

            <Item
              colSpan={3}
              dataField="category_code"
              editorType="dxLookup"
              visible={with_categories}
              editorOptions={
                {
                  dataSource: schemeCategoriesStore,
                  displayExpr: "description",
                  valueExpr: "CategoryCode",
                  searchEnabled: false
                }
              }
            >
              {with_categories && <RequiredRule message="Scheme Category is required" />}
              <Label text='Scheme Category' />
            </Item>

            <Item
              colSpan={2}
              dataField="MemberName"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);

                    }
                  }
                }
              }
            >
              <RequiredRule message="Member Name is required" />
              <Label text='Name' />
            </Item>

            <Item
              dataField="MemberNo"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);

                    }
                  }
                }
              }
            >
              <RequiredRule message="Member No is required" />
              <Label text='Member No' />
            </Item>


            <Item
              colSpan={2}
              dataField="MemberEmail"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);
                    }
                  }
                }
              }
            >
              {/* <RequiredRule message="Member Email is required" /> */}
              <Label text='Member Email' />
            </Item>

            <Item
              dataField="DateOfBirth"
              editorType="dxDateBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);
                      const age = calculateAge(e.value);

                      var selectedDate = e.value;
                      var currentDate = new Date();

                      // Compare the selected date with the current date
                      if (selectedDate > currentDate) {
                        notify('Future Date of Birth is not allowed', 'error', 5000);
                        e.component.option("value", null); // Reset the value
                        return;
                      }

                      if (age < 18 || age > 80) {
                        // Clear the value if age is not within the range
                        e.component.option('value', null);
                        // You can also provide feedback to the user that the value is invalid
                        notify('Date of Birth must be between 18 and 80 years old', 'error', 5000);
                      } else {
                        console.log(age);
                        formData.current.MemberAge = age;
                        setMemberAge(age);

                        //setMemberStore(prevData => ({ ...prevData, MemberAge: age }));
                      }
                    }
                  }
                }
              }
            >
              <RequiredRule text="Date of Birth is Required is required" />
              <Label text='Date of Birth' />
            </Item>

            <Item
              dataField="MemberAge"
              editorType="dxNumberBox"
              editorOptions={
                {
                  readOnly: true,
                  value: MemberAge
                }
              }
            >
              {/* <RequiredRule message="Age is required" /> */}
              <Label text='Age' />
            </Item>



            <Item
              dataField="id_number"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);

                    }
                  }
                }
              }
            >
              <RequiredRule message="ID Number is required" />
              <Label text='ID / Passport Number' />
            </Item>




            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            

            <Item
              dataField="date_of_loan"
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      //get the cover periods dates

                      // const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === formData.scheme_id);

                      // // Assign the name to the variable 'ans'
                      // const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                      // const End_date = SchemeDetails ? SchemeDetails.End_date : null;

                      // if (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value))) {
                      //   console.log(new Date(e.value));

                      // } else {
                      //   // Clear the value if age is not within the range
                      //   e.component.option('value', null);
                      //   // You can also provide feedback to the user that the value is invalid
                      //   notify('Start Date is Outside the cover period', 'error', 5000);
                      // }
                    }
                  }
                }
              }
            >
              {/* <RequiredRule message="Joining Date is required" /> */}
              {/* <CustomRule
                message="Start Date is Outside the cover period"
                validationCallback={
                  (e) => {

                    const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === formData.scheme_id);

                    // Assign the name to the variable 'ans'
                    const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
                    const End_date = SchemeDetails ? SchemeDetails.End_date : null;
                    return (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(e.value)));
                  }
                }
              /> */}
              <RequiredRule message="Loan Start Date is required" />
              <Label text='Loan Start Date' />
            </Item>



            <Item
              dataField="loan_number"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      console.log(e.value);

                    }
                  }
                }
              }
            >
              <RequiredRule message="Loan No is required" />
              <Label text='Loan No' />
            </Item>

            {/* <Item
              dataField=""
              editorType="dxDateBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {
                      
                    }
                  }
                }
              }
            >
              <RequiredRule message="Loan Start Date is required" />
              <Label text='Loan Start Date' />
            </Item> */}


            <Item

              dataField={'LoanAmount'}
              editorType={'dxNumberBox'}
              editorOptions={
                {
                  format: ",##0.###",
                }
              }
            >
              <RequiredRule message="Loan Amount is required" />
              <Label visible={true} text='Loan Amount' />
            </Item>

            <Item

              dataField={'duration'}
              editorType={'dxNumberBox'}
              editorOptions={
                {
                  format: ",##0.###",
                }
              }
            >
              <RequiredRule message="Loan Tenure is required" />
              <Label visible={true} text='Loan Tenure' />
            </Item>

            {/* <Item

              dataField={'interest_rate'}
              editorType={'dxNumberBox'}
              editorOptions={
                {
                  format: ",##0.###",
                }
              }
            >
              <RequiredRule message="Loan Interest Rate is required" /> 
              <Label visible={true} text='Loan Interest Rate' />
            </Item> */}

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />


            <Item
              colSpan={3}
              dataField="requested_change"
              editorType="dxTextArea"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    if (e.value !== undefined && e.value !== null && e.value !== '') {

                    }
                  }
                }
              }
            >
              <RequiredRule message="Narration is required" />
              <Label text='Narration' />
            </Item>

            <Item {...emptyItemConfig} />

            <ButtonItem
              colSpan={3}
            >
              <ButtonOptions
                type={'default'}
                icon='save'
                text='SUBMIT'
                useSubmitBehavior={true}
              >
              </ButtonOptions>
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>

    </div>
  );
}

export default Supplimentary;